import { API_URL, MOKA_SERVICE_HOST } from '../constants';

export const EMPLOYEES_SERVICE_V1 = `${MOKA_SERVICE_HOST}/account/v1/employees`;

export const PERMISSIONS_V1 = (employeeId) =>
  `${EMPLOYEES_SERVICE_V1}/${employeeId}/permissions`;

export const PERMISSIONS_LOGGEDIN_USER = `${MOKA_SERVICE_HOST}/account/v1/permissions`;

export const EMPLOYEES_SERVICE_EXPORT_V1 = `${EMPLOYEES_SERVICE_V1}/export`;

export const EMPLOYEES_SERVICE_V1_ID = (id) => `${EMPLOYEES_SERVICE_V1}/${id}`;

export const EMPLOYEES = `${API_URL}/v1/employees`;
export const ASSIGNED_STAFF = `${API_URL}/v1/employees/get_assigned_staff`;
export const EMPLOYEE = (id) => `${API_URL}/v1/employees/${id}`;

export const RESEND_INVITATION = `${API_URL}/v1/employees/resend_invitation`;

export const ACTIVE_EMPLOYEES = `${MOKA_SERVICE_HOST}/account/v1/slots`;

export const EMPLOYEE_SLOT_V1_ID = (slotId) => `${ACTIVE_EMPLOYEES}/${slotId}`;

export const OUTLETS_EMPLOYEES = `${MOKA_SERVICE_HOST}/account/v2/outlets`;
